export enum EntitySpaceType {
  dept = "dept",
  group = "group",
}
